export default (props, e) => {
  e.stopPropagation();
  let toggles = document.querySelectorAll('.submenu__toggle');
  let target = e.target;

  if(target.classList.contains('active')) {
    target.classList.toggle('active');
  }else {
    toggles.forEach(t=> t.classList.remove('active'));
    target.classList.add('active');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/actions/submenuToggle.js